/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props */
import { WithPreview } from "@quintype/components";
import get from "lodash/get";
import { any, number, object, shape } from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { checkIfStoryPublic } from "../../access-type-utils";
import { storyFields } from "../../constants";
import { useVerifyGiftStoryToken } from "../atoms/gift-story/useVerifyGiftStoryToken";
import { HindiLoginBanner } from "../hindi-login-banner";
import { RelatedStories } from "../molecules/related-stories";
import { GumletVideo } from "../story-templates/gumlet-video";
import { Listicle } from "../story-templates/listicle";
import { LiveBlog } from "../story-templates/live-blog/live-blog";
import { LiveQA } from "../story-templates/live-qa";
import { PaywallComicsTemplate } from "../story-templates/paywall-comics";
import { PhotoStory } from "../story-templates/photo-story";
import { Podcast } from "../story-templates/podcast";
import { TextSTory } from "../story-templates/text-story/text-story";
import { VideoStory } from "../story-templates/video-story";
import { fetchDataFromLocalStorage } from "./subscription-checkout/utils";

function StoryPageBase({ story, params, setLiveQA }) {
  const { fetchSubscription, member } = useSelector(state => state);
  const [hasUserGivenEmail, setHasUserGivenEmail] = useState(null);
  const [toShowHindiLoginBanner, setToShowHindiLoginBanner] = useState(false);
  const [isHindi, setIsHindi] = useState(false);

  const isStoryPublic = checkIfStoryPublic(story);

  const isGiftTokenValid = useVerifyGiftStoryToken(story);
  const memoizedStory = useMemo(
    () => ({ ...story, isAGiftStory: isGiftTokenValid }),
    [isGiftTokenValid]
  );

  const storyCopy = Object.assign({}, memoizedStory);
  const getFirstStoryCard = {
    cards: [memoizedStory && memoizedStory.cards && memoizedStory.cards[0]]
  };
  const newStory = Object.assign(storyCopy, getFirstStoryCard);

  const cumulativeContentCategory = story.sections
    .map(sec => sec.name)
    .join(",");

  const pushToDataLayer = () => {
    const obj = {
      event: "article_viewed",
      content_name: story.headline,
      content_category: story.sections[0].name,
      cumulative_content_category: cumulativeContentCategory || "",
      content_creator: story["author-name"],
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    window.dataLayer.push(obj);
  };

  useEffect(() => {
    const x = document.querySelectorAll(".story-element-text a");
    [...x].forEach(x => x.setAttribute("target", "_blank"));

    const userEmail = fetchDataFromLocalStorage("hasUserGivenEmail");

    // if (userEmail) {
    //   setHasUserGivenEmail(userEmail);
    // } else {
    //   setToShowHindiLoginBanner(true);
    // }

    const hindiCheck = !!(
      global.location && global.location.host.includes("hindi")
    );
    setIsHindi(hindiCheck);

    pushToDataLayer();
  }, []);

  // const defaultFallbackImageURL =
  //   "https://images.assettype.com/newslaundry/2023-01/6cd716aa-303c-4a80-af64-2ccff58edc2a/default_fallback.jpeg";

  const showHindiBanner =
    isHindi && toShowHindiLoginBanner && !hasUserGivenEmail && isStoryPublic;

  // Can switch to a different template based story-template, or only show a spoiler if index > 0
  switch (memoizedStory["story-template"]) {
    case "live-blog":
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <LiveBlog
            story={memoizedStory}
            cardId={get(params, ["cardId"])}
            newStory={newStory}
          />{" "}
        </div>
      );
    case "live-qa":
      setLiveQA(true);
      return (
        <div>
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <LiveQA story={memoizedStory} newStory={newStory} />
        </div>
      );
    case "listicle":
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <Listicle story={memoizedStory} newStory={newStory} />{" "}
        </div>
      );
    case "video":
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <VideoStory story={memoizedStory} newStory={newStory} />
        </div>
      );
    case "gumlet-video":
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <GumletVideo story={memoizedStory} newStory={newStory} />
        </div>
      );
    case "podcast":
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <Podcast story={memoizedStory} newStory={newStory} />
        </div>
      );
    case "photo":
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <PhotoStory story={memoizedStory} newStory={newStory} />
        </div>
      );
    case "paywall-comics":
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <PaywallComicsTemplate story={memoizedStory} newStory={newStory} />
        </div>
      );
    default:
      return (
        <div className="full-width-with-padding separator">
          {showHindiBanner && (
            <HindiLoginBanner
              setToShowHindiLoginBanner={setToShowHindiLoginBanner}
            />
          )}
          <TextSTory story={memoizedStory} newStory={newStory} />
        </div>
      );
  }
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  otherProp: any,
  params: object
};

function storyPageLoadItems(pageNumber) {
  return global
    .wretch("/api/v1/stories")
    .query({
      fields: storyFields,
      limit: 5,
      offset: 5 * pageNumber
    })
    .get()
    .json(response =>
      response.stories.map(story => ({ story, otherProp: "value" }))
    );
}

export function StoryPage(props) {
  const [liveQA, setLiveQA] = React.useState(false);
  return (
    <>
      <StoryPageBase {...props.data} setLiveQA={setLiveQA}></StoryPageBase>
      {!liveQA ? <RelatedStories story={props.data.story} /> : null}
    </>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object
  })
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story)
  })
);
